import React from "react";
import { Box, Container, Divider, Flex, Link, Stack, Text, VStack } from "@chakra-ui/react";
import { company, contact, navLinks } from "../data/content";

export default function Footer() {
  return (
    <Box as="footer" bg="ink.800" color="whiteAlpha.800">
      <Container maxW="6xl" px={{ base: 5, md: 8 }} py={{ base: 12, md: 16 }}>
        <Stack direction={{ base: "column", md: "row" }} spacing={10} justify="space-between">
          <VStack align={{ base: "center", md: "start" }} spacing={2} maxW="sm" textAlign={{ base: "center", md: "left" }}>
            <Text fontWeight={700} color="white" fontSize="lg">
              {company.name}
            </Text>
            <Text className="arabic" dir="rtl" fontSize="sm">
              {company.legalNameAr}
            </Text>
            <Text fontSize="sm" color="whiteAlpha.600">
              {company.legalNameEn}
            </Text>
            <Text fontSize="sm" color="brand.300" fontWeight={600} pt={1}>
              {company.tagline}
            </Text>
          </VStack>

          <VStack align={{ base: "center", md: "start" }} spacing={2}>
            <Text fontWeight={600} color="white" fontSize="sm" textTransform="uppercase" letterSpacing="0.08em">
              Explore
            </Text>
            {navLinks.map((link) => (
              <Link key={link.href} href={link.href} fontSize="sm" _hover={{ color: "brand.300" }}>
                {link.label}
              </Link>
            ))}
          </VStack>

          <VStack align={{ base: "center", md: "start" }} spacing={2}>
            <Text fontWeight={600} color="white" fontSize="sm" textTransform="uppercase" letterSpacing="0.08em">
              Contact
            </Text>
            <Link href={contact.phoneHref} fontSize="sm" _hover={{ color: "brand.300" }}>
              {contact.phoneDisplay}
            </Link>
            <Link href={contact.emailHref} fontSize="sm" _hover={{ color: "brand.300" }}>
              {contact.email}
            </Link>
            <Text fontSize="sm">{contact.address}</Text>
          </VStack>
        </Stack>

        <Divider my={8} borderColor="whiteAlpha.300" />

        <Flex
          direction={{ base: "column", sm: "row" }}
          justify="space-between"
          align="center"
          gap={2}
          fontSize="sm"
          color="whiteAlpha.600"
        >
          <Text>
            © {new Date().getFullYear()} {company.name}. All rights reserved.
          </Text>
          <Text>{contact.website}</Text>
        </Flex>
      </Container>
    </Box>
  );
}
